// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3eDbb","signatureButtonsRight":"ModalSign_signatureButtonsRight__32Fdj"};